import React from 'react'
import PropTypes from 'prop-types'

function InfoRow ({ label, children }) {
  return (
    <div style={{ display: 'flex', padding: '0.35rem 0', borderBottom: '1px solid #eee' }}>
      <span style={{ fontWeight: 600, width: 180, flexShrink: 0 }}>{label}</span>
      <span style={{ flex: 1 }}>{children}</span>
    </div>
  )
}

InfoRow.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node
}

export default InfoRow
